import { Component, OnInit } from '@angular/core';
import { GlobalVariableService } from '../../Shared/global-variable.service';
import { HttpServiceService } from '../../Services/http-service.service';
import { ScrambleUnscrambleService } from '../../Services/scramble-unscramble.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/Services/alert.service';
import { Router } from '@angular/router'
import { DeviceDetectorService } from 'ngx-device-detector';
import { MaterialModule } from 'src/app/Shared/Material/material.module';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})

export class ContactUsComponent implements OnInit {
  public color;
  public btBorder;
  nisusfin3:boolean = false;
  kotak1:boolean = false;
  nisusfin1:boolean = false;
  vishuddha1:boolean = false;
  oldBridge:boolean = false;
  iifl:boolean = false;
  chiratae:boolean = false;
  shepheredsHill1:boolean = false;
  sparkAsset:boolean = false;
  spark:boolean = false;
  heliosshow: boolean = false;
  kotakAlternate: boolean = false;
  contactdetails: any = [];
  address1: any;
  address2: any;
  address3: string;
  address4: any;
  address5: string;
  
  constructor(private _globalVariableService: GlobalVariableService,
    private spinnerService: NgxSpinnerService,
    private alertService:AlertService,
    private _httpService:HttpServiceService,
    private router: Router,
    private _scrambleUnscrambleService: ScrambleUnscrambleService,
    private detectorService: DeviceDetectorService) {
    this.color = this._globalVariableService.color;
    this.btBorder = "2px solid " + this._globalVariableService.themeColor;
    if(this._globalVariableService.amc_name == "dnisus"){
      this.nisusfin3 = true;
    }
    else if(this._globalVariableService.amc_name == "nisus"){
      this.nisusfin1 = true;
    }
    else if(this._globalVariableService.amc_name == "kotak"){
      this.kotak1 = true;
    } 
    else if(this._globalVariableService.amc_name == "helios"){
      this.heliosshow = true;
    }
    else if(this._globalVariableService.amc_name == "chiratae"){
      this.nisusfin3 = true;
    }
    else if(this._globalVariableService.amc_name == "centrum"){
      this.nisusfin3 = true;
    } 
    else if(this._globalVariableService.amc_name == "whiteoak"){
      this.nisusfin3 = true;
    }
    else if(this._globalVariableService.amc_name == "kotakAlternate"){
      this.kotakAlternate = true;
    }
    else if(this._globalVariableService.amc_name == "abakkus"){
      this.nisusfin3 = true;
    }
   
    else if(this._globalVariableService.amc_name == "peninsula"){
      this.nisusfin3 = true;
    }
    else if(this._globalVariableService.amc_name == "JonesLang"){
      this.nisusfin3 = true;
    }
    else if(this._globalVariableService.amc_name == "vishuddha"){
      this.vishuddha1 = true;
    }
    else if(this._globalVariableService.amc_name == "shepheredsHill"){
      this.shepheredsHill1 = true;
    }
    else if(this._globalVariableService.amc_name == "spark"){
      this.spark = true;
    }
    else if(this._globalVariableService.amc_name == "sparkAsset"){
      this.sparkAsset = true;
    }
    else if(this._globalVariableService.amc_name == "oldBridge"){
      this.oldBridge = true;
    }
    else if(this._globalVariableService.amc_name == "IIFL"){
      this.iifl = true;
    }
  }

  ngOnInit() {
    this.getContactdetails();
    
  }
  getContactdetails() {
    if(this._globalVariableService.amc_name == "kotak" || this._globalVariableService.amc_name == "helios"|| this._globalVariableService.amc_name == "IIFL" ||  this._globalVariableService.amc_name == "kotakAlternate"|| this._globalVariableService.amc_name == "oldBridge"|| this._globalVariableService.amc_name == "Artha"  ){}
    else{
      let authid = sessionStorage.getItem("KrCGei");
      var sessionDetails = this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", sessionStorage.getItem("ZhJtE" + authid), this._httpService.scrambleKey);
      sessionDetails = JSON.parse(sessionDetails);
      let contactDetails: any = {
        "flag":"GET_CONTACT_DETAILS",
        "device_id":this.detectorService.getDeviceInfo().browser,
        "os_id":this.detectorService.getDeviceInfo().os + " - " + this.detectorService.getDeviceInfo().os_version,
        "session_id": sessionDetails[0].sessionid,
        "tax_no":sessionDetails[0].pannumber,
        "amc_code":this._globalVariableService.amc_code
      }
      // //console.log(contactDetails)
      this.spinnerService.show();
      this._httpService.getcontactDetails(contactDetails).subscribe((data) => {
        data = JSON.parse(this._scrambleUnscrambleService.pefundApplyInternalFilter("Unveil", data, this._httpService.unscrambleKey));
        //console.log(data)
        if (data.status.errorflag == true) {
          this.alertService.errorMsg(data.status.errormsg);
          this.spinnerService.hide();
        
          return;
        } else {
           this.contactdetails = data.detail;
           //console.log(this.contactdetails,"contact details");
           if(this.contactdetails[0].AMC_CODE == '76'){
            let text = this.contactdetails[0].SERVICE_ADDRESS;
            this.address1 = text.split("Chennai - 600002.")[0];
            this.address2 = 'Chennai - 600002,';
            this.address3 = text.split("Chennai - 600002.")[1];
            this.address4 = this.address3.split("Email")[0];
            this.address4 = this.address4.replace("Mobile","Telephone");
            this.address5 = this.address3.split("679")[1];
            //console.log( this.address4 )
          }
          this.spinnerService.hide();
        }
        
      });
  
    }
  
    }
}